<div class="dropdown">
  <div (click)="toggleDropdown()" 
    class="flex items-center justify-between justify-center dropdown-header"
    [class]="showBody === false ? 'border-bottom' : ''"
  >
    <div>
      <p>
        {{title}}
      </p>
    </div>

    <div>
      <svg *ngIf="showBody === false" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7955 16.1705C12.3562 16.6098 11.6438 16.6098 11.2045 16.1705L4.45451 9.42049C4.01517 8.98115 4.01517 8.26884 4.45451 7.8295C4.89385 7.39016 5.60616 7.39016 6.04549 7.8295L12 13.784L17.9545 7.8295C18.3938 7.39017 19.1062 7.39017 19.5455 7.8295C19.9848 8.26884 19.9848 8.98116 19.5455 9.4205L12.7955 16.1705Z" fill="#0361F0"/>
      </svg>        

      <svg *ngIf="showBody === true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2045 7.8295C11.6438 7.39017 12.3562 7.39017 12.7955 7.8295L19.5455 14.5795C19.9848 15.0188 19.9848 15.7312 19.5455 16.1705C19.1062 16.6098 18.3938 16.6098 17.9545 16.1705L12 10.216L6.0455 16.1705C5.60616 16.6098 4.89384 16.6098 4.4545 16.1705C4.01517 15.7312 4.01517 15.0188 4.4545 14.5795L11.2045 7.8295Z" fill="#0361F0"/>
      </svg>        
    </div>
  </div>


  <div *ngIf="showBody === true" class="dropdown-body">
    <ng-content></ng-content>
  </div>
</div>